// This file was auto-generated by NTypewriter for DA.Types.Shared.LogLevel
export enum LogLevel {
	Information = 'information',
	Warning = 'warning',
	Error = 'error',
	CriticalError = 'criticalError',
}
